import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.array.fill";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.number.constructor";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.regexp.constructor";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.function.name";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.string.bold";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.object.assign";
import e, { forwardRef as t, createElement as o } from "react";
import r from "object-assign";
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var _n = function n() {
  return (_n = Object.assign || function (e) {
    for (var t, o = 1, r = arguments.length; o < r; o++) {
      for (var n in t = arguments[o]) {
        Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
      }
    }

    return e;
  }).apply(this, arguments);
};

function l(e, t) {
  var o = {};

  for (var r in e) {
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (o[r] = e[r]);
  }

  if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
    var n = 0;

    for (r = Object.getOwnPropertySymbols(e); n < r.length; n++) {
      t.indexOf(r[n]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[n]) && (o[r[n]] = e[r[n]]);
    }
  }

  return o;
}

function i(e, t, o) {
  return e(o = {
    path: t,
    exports: {},
    require: function require(e, t) {
      return function () {
        throw new Error("Dynamic requires are not currently supported by @rollup/plugin-commonjs");
      }(null == t && o.path);
    }
  }, o.exports), o.exports;
}

var a,
    d,
    s,
    c,
    u,
    f = i(function (e) {
  /*!
    Copyright (c) 2017 Jed Watson.
    Licensed under the MIT License (MIT), see
    http://jedwatson.github.io/classnames
  */
  !function () {
    var t = {}.hasOwnProperty;

    function o() {
      for (var e = [], r = 0; r < arguments.length; r++) {
        var n = arguments[r];

        if (n) {
          var l = typeof n;
          if ("string" === l || "number" === l) e.push(n);else if (Array.isArray(n) && n.length) {
            var i = o.apply(null, n);
            i && e.push(i);
          } else if ("object" === l) for (var a in n) {
            t.call(n, a) && n[a] && e.push(a);
          }
        }
      }

      return e.join(" ");
    }

    e.exports ? (o.default = o, e.exports = o) : window.classNames = o;
  }();
}),
    m = {
  textSize5XL: "text-module_textSize5XL__3BbOO",
  textSize4XL: "text-module_textSize4XL__2o8-D",
  textSize3XL: "text-module_textSize3XL__1LOTE",
  textSizeXXL: "text-module_textSizeXXL__1wMH_",
  textSizeXL: "text-module_textSizeXL__oegRg",
  textSizeL: "text-module_textSizeL__2tgKm",
  textSizeM: "text-module_textSizeM__HyNZD",
  textSizeS: "text-module_textSizeS__1D5cE",
  textSizeXS: "text-module_textSizeXS__2-bAW",
  textSizeXXS: "text-module_textSizeXXS__2BFm4",
  textSize3XS: "text-module_textSize3XS__1woAU",
  textSize4XS: "text-module_textSize4XS__29lV_",
  textWeightLIGHT: "text-module_textWeightLIGHT__2W69u",
  textWeightBOOK: "text-module_textWeightBOOK__2fZt2",
  textWeightMEDIUM: "text-module_textWeightMEDIUM__3rg1b",
  textWeightSEMIBOLD: "text-module_textWeightSEMIBOLD__LAg-A",
  textWeightBOLD: "text-module_textWeightBOLD__2OC3b",
  textFontStyleNORMAL: "text-module_textFontStyleNORMAL__2VQ0l",
  textFontStyleITALIC: "text-module_textFontStyleITALIC__bwbae",
  textLineHeightBODY: "text-module_textLineHeightBODY__wLFJF",
  textLineHeightDISPLAY: "text-module_textLineHeightDISPLAY__32E-9",
  vehicleTitle: "text-module_vehicleTitle__PXBaL",
  vehiclePrice: "text-module_vehiclePrice__3hHqk",
  vehicleSubTitle: "text-module_vehicleSubTitle__1rAIc",
  cardTitle: "text-module_cardTitle__ZQNEh",
  body2: "text-module_body2__PKOoW",
  button: "text-module_button__TpASo",
  overline: "text-module_overline__qZjZZ",
  fieldHelpText: "text-module_fieldHelpText__1NS49"
};
!function (e) {
  e["5xl"] = "5xl", e["4xl"] = "4xl", e["3xl"] = "3xl", e.xxl = "xxl", e.xl = "xl", e.l = "l", e.m = "m", e.s = "s", e.xs = "xs", e["3xs"] = "3xs", e["4xs"] = "4xs";
}(a || (a = {})), function (e) {
  e.light = "light", e.book = "book", e.medium = "medium", e.semibold = "semibold", e.bold = "bold";
}(d || (d = {})), function (e) {
  e.display = "display", e.body = "body";
}(s || (s = {})), function (e) {
  e.italic = "italic", e.normal = "normal";
}(c || (c = {})), function (e) {
  e.test = "test", e.mainTitle = "mainTitle", e.vehicleTitle = "vehicleTitle", e.vehicleSubTitle = "vehicleSubTitle", e.vehiclePrice = "vehiclePrice", e.vehicleBody = "vehicleBody", e.cardTitle = "cardTitle", e.menuTitle = "menuTitle", e.menuItem = "menuItem", e.bullet = "bullet", e.cardFocalText = "cardFocalText", e.body1 = "body1", e.body2 = "body2", e.button = "button", e.caption = "caption", e.smallCaption = "smallCaption", e.overline = "overline", e.fieldHelpText = "fieldHelpText";
}(u || (u = {}));
var p,
    x = {
  base: "text-oxford-module_base__MEDZv",
  vehicleTitle: "text-oxford-module_vehicleTitle__2Bui4",
  vehiclePrice: "text-oxford-module_vehiclePrice__uogU2",
  cardFocalText: "text-oxford-module_cardFocalText__3vA0b",
  mainTitle: "text-oxford-module_mainTitle__nGbGM",
  vehicleSubTitle: "text-oxford-module_vehicleSubTitle__3b6aO",
  cardTitle: "text-oxford-module_cardTitle__23Rka",
  menuTitle: "text-oxford-module_menuTitle__qnR-1",
  body1: "text-oxford-module_body1__1kami",
  body2: "text-oxford-module_body2__1HgMA",
  button: "text-oxford-module_button__2E7Ck",
  vehicleBody: "text-oxford-module_vehicleBody__3KNML",
  menuItem: "text-oxford-module_menuItem__SE3S8",
  bullet: "text-oxford-module_bullet__27oUf",
  caption: "text-oxford-module_caption__15iiW",
  smallCaption: "text-oxford-module_smallCaption__ngeiG",
  overline: "text-oxford-module_overline__178C0",
  fieldHelpText: "text-oxford-module_fieldHelpText__3VEoh"
};
!function (e) {
  e.test = "test", e.mainTitle = "mainTitle", e.vehicleTitle = "vehicleTitle", e.vehicleSubTitle = "vehicleSubTitle", e.vehiclePrice = "vehiclePrice", e.vehicleBody = "vehicleBody", e.cardTitle = "cardTitle", e.menuTitle = "menuTitle", e.menuItem = "menuItem", e.bullet = "bullet", e.cardFocalText = "cardFocalText", e.body1 = "body1", e.body2 = "body2", e.button = "button", e.caption = "caption", e.smallCaption = "smallCaption", e.overline = "overline", e.fieldHelpText = "fieldHelpText";
}(p || (p = {}));

var b = function b(t) {
  var o = t.className,
      r = t.children,
      i = t.element,
      a = void 0 === i ? "span" : i,
      d = t.type,
      s = void 0 === d ? p.body1 : d,
      c = l(t, ["className", "children", "element", "type"]),
      u = f(o, x.base, x[s]);
  return e.createElement(a, _n(_n({
    className: u
  }, c), {
    "data-testid": "oxd-text"
  }), r);
},
    v = {
  test: {
    fontSize: a.xxl,
    fontWeight: d.bold,
    lineHeight: s.display,
    fontStyle: c.italic
  },
  mainTitle: {
    fontSize: a.xxl,
    fontWeight: d.bold,
    lineHeight: s.display
  },
  vehicleTitle: {
    fontSize: a["4xl"],
    fontWeight: d.bold
  },
  vehicleSubTitle: {
    fontSize: a.xl,
    fontWeight: d.bold
  },
  vehiclePrice: {
    fontSize: a["3xl"],
    fontWeight: d.semibold
  },
  vehicleBody: {
    fontSize: a.xs,
    fontWeight: d.medium
  },
  cardTitle: {
    fontSize: a.m,
    fontWeight: d.semibold
  },
  menuTitle: {
    fontSize: a.m,
    fontWeight: d.semibold
  },
  menuItem: {
    fontSize: a.m,
    fontWeight: d.bold
  },
  bullet: {
    fontSize: a.xs,
    fontWeight: d.book
  },
  cardFocalText: {
    fontSize: a["3xl"],
    fontWeight: d.bold
  },
  body1: {
    fontSize: a.m,
    fontWeight: d.book
  },
  body2: {
    fontSize: a.s,
    fontWeight: d.medium
  },
  button: {
    fontSize: a.s,
    fontWeight: d.medium
  },
  caption: {
    fontSize: a["3xs"],
    fontWeight: d.book
  },
  smallCaption: {
    fontSize: a["3xs"],
    fontWeight: d.medium
  },
  overline: {
    fontSize: a["3xs"],
    fontWeight: d.book
  },
  fieldHelpText: {
    fontSize: a["3xs"],
    fontWeight: d.book
  }
},
    _ = function _(t) {
  var o = t.children,
      r = t.fontSize,
      i = void 0 === r ? "m" : r,
      a = t.fontWeight,
      d = void 0 === a ? "medium" : a,
      s = t.fontStyle,
      c = void 0 === s ? "normal" : s,
      p = t.lineHeight,
      x = void 0 === p ? "body" : p,
      _ = t.element,
      y = void 0 === _ ? "p" : _,
      h = t.oxford,
      g = void 0 !== h && h,
      S = t.type,
      E = t.className,
      w = l(t, ["children", "fontSize", "fontWeight", "fontStyle", "lineHeight", "element", "oxford", "type", "className"]);
  if (g) return e.createElement(b, _n({
    element: y,
    className: E,
    type: S || u.body1
  }, w), o);
  var O = y,
      N = S ? v[S] : {},
      T = f([m["textSize" + (N.fontSize ? N.fontSize.toUpperCase() : i.toUpperCase())]], [m["textWeight" + (N.fontWeight ? N.fontWeight.toUpperCase() : d.toUpperCase())]], [m["textLineHeight" + (N.lineHeight ? N.lineHeight.toUpperCase() : x.toUpperCase())]], [m["textFontStyle" + (N.fontStyle ? N.fontStyle.toUpperCase() : c.toUpperCase())]], E, S && m[S] || S);
  return e.createElement(O, _n({
    className: T
  }, w), o);
},
    y = "field-error-module_error__kMErP",
    h = "field-error-module_icon__1u37t",
    g = "field-error-module_message__1Y6WN",
    S = "function" == typeof Symbol && Symbol.for,
    E = S ? Symbol.for("react.element") : 60103,
    w = S ? Symbol.for("react.portal") : 60106,
    O = S ? Symbol.for("react.fragment") : 60107,
    N = S ? Symbol.for("react.strict_mode") : 60108,
    T = S ? Symbol.for("react.profiler") : 60114,
    z = S ? Symbol.for("react.provider") : 60109,
    F = S ? Symbol.for("react.context") : 60110,
    j = S ? Symbol.for("react.async_mode") : 60111,
    k = S ? Symbol.for("react.concurrent_mode") : 60111,
    P = S ? Symbol.for("react.forward_ref") : 60112,
    C = S ? Symbol.for("react.suspense") : 60113,
    I = S ? Symbol.for("react.suspense_list") : 60120,
    W = S ? Symbol.for("react.memo") : 60115,
    L = S ? Symbol.for("react.lazy") : 60116,
    B = S ? Symbol.for("react.block") : 60121,
    A = S ? Symbol.for("react.fundamental") : 60117,
    M = S ? Symbol.for("react.responder") : 60118,
    D = S ? Symbol.for("react.scope") : 60119;

function R(e) {
  if ("object" == typeof e && null !== e) {
    var t = e.$$typeof;

    switch (t) {
      case E:
        switch (e = e.type) {
          case j:
          case k:
          case O:
          case T:
          case N:
          case C:
            return e;

          default:
            switch (e = e && e.$$typeof) {
              case F:
              case P:
              case L:
              case W:
              case z:
                return e;

              default:
                return t;
            }

        }

      case w:
        return t;
    }
  }
}

function $(e) {
  return R(e) === k;
}

var H = {
  AsyncMode: j,
  ConcurrentMode: k,
  ContextConsumer: F,
  ContextProvider: z,
  Element: E,
  ForwardRef: P,
  Fragment: O,
  Lazy: L,
  Memo: W,
  Portal: w,
  Profiler: T,
  StrictMode: N,
  Suspense: C,
  isAsyncMode: function isAsyncMode(e) {
    return $(e) || R(e) === j;
  },
  isConcurrentMode: $,
  isContextConsumer: function isContextConsumer(e) {
    return R(e) === F;
  },
  isContextProvider: function isContextProvider(e) {
    return R(e) === z;
  },
  isElement: function isElement(e) {
    return "object" == typeof e && null !== e && e.$$typeof === E;
  },
  isForwardRef: function isForwardRef(e) {
    return R(e) === P;
  },
  isFragment: function isFragment(e) {
    return R(e) === O;
  },
  isLazy: function isLazy(e) {
    return R(e) === L;
  },
  isMemo: function isMemo(e) {
    return R(e) === W;
  },
  isPortal: function isPortal(e) {
    return R(e) === w;
  },
  isProfiler: function isProfiler(e) {
    return R(e) === T;
  },
  isStrictMode: function isStrictMode(e) {
    return R(e) === N;
  },
  isSuspense: function isSuspense(e) {
    return R(e) === C;
  },
  isValidElementType: function isValidElementType(e) {
    return "string" == typeof e || "function" == typeof e || e === O || e === k || e === T || e === N || e === C || e === I || "object" == typeof e && null !== e && (e.$$typeof === L || e.$$typeof === W || e.$$typeof === z || e.$$typeof === F || e.$$typeof === P || e.$$typeof === A || e.$$typeof === M || e.$$typeof === D || e.$$typeof === B);
  },
  typeOf: R
},
    V = i(function (e, t) {
  "production" !== process.env.NODE_ENV && function () {
    var e = "function" == typeof Symbol && Symbol.for,
        o = e ? Symbol.for("react.element") : 60103,
        r = e ? Symbol.for("react.portal") : 60106,
        n = e ? Symbol.for("react.fragment") : 60107,
        l = e ? Symbol.for("react.strict_mode") : 60108,
        i = e ? Symbol.for("react.profiler") : 60114,
        a = e ? Symbol.for("react.provider") : 60109,
        d = e ? Symbol.for("react.context") : 60110,
        s = e ? Symbol.for("react.async_mode") : 60111,
        c = e ? Symbol.for("react.concurrent_mode") : 60111,
        u = e ? Symbol.for("react.forward_ref") : 60112,
        f = e ? Symbol.for("react.suspense") : 60113,
        m = e ? Symbol.for("react.suspense_list") : 60120,
        p = e ? Symbol.for("react.memo") : 60115,
        x = e ? Symbol.for("react.lazy") : 60116,
        b = e ? Symbol.for("react.block") : 60121,
        v = e ? Symbol.for("react.fundamental") : 60117,
        _ = e ? Symbol.for("react.responder") : 60118,
        y = e ? Symbol.for("react.scope") : 60119;

    function h(e) {
      if ("object" == typeof e && null !== e) {
        var t = e.$$typeof;

        switch (t) {
          case o:
            var m = e.type;

            switch (m) {
              case s:
              case c:
              case n:
              case i:
              case l:
              case f:
                return m;

              default:
                var b = m && m.$$typeof;

                switch (b) {
                  case d:
                  case u:
                  case x:
                  case p:
                  case a:
                    return b;

                  default:
                    return t;
                }

            }

          case r:
            return t;
        }
      }
    }

    var g = s,
        S = c,
        E = d,
        w = a,
        O = o,
        N = u,
        T = n,
        z = x,
        F = p,
        j = r,
        k = i,
        P = l,
        C = f,
        I = !1;

    function W(e) {
      return h(e) === c;
    }

    t.AsyncMode = g, t.ConcurrentMode = S, t.ContextConsumer = E, t.ContextProvider = w, t.Element = O, t.ForwardRef = N, t.Fragment = T, t.Lazy = z, t.Memo = F, t.Portal = j, t.Profiler = k, t.StrictMode = P, t.Suspense = C, t.isAsyncMode = function (e) {
      return I || (I = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), W(e) || h(e) === s;
    }, t.isConcurrentMode = W, t.isContextConsumer = function (e) {
      return h(e) === d;
    }, t.isContextProvider = function (e) {
      return h(e) === a;
    }, t.isElement = function (e) {
      return "object" == typeof e && null !== e && e.$$typeof === o;
    }, t.isForwardRef = function (e) {
      return h(e) === u;
    }, t.isFragment = function (e) {
      return h(e) === n;
    }, t.isLazy = function (e) {
      return h(e) === x;
    }, t.isMemo = function (e) {
      return h(e) === p;
    }, t.isPortal = function (e) {
      return h(e) === r;
    }, t.isProfiler = function (e) {
      return h(e) === i;
    }, t.isStrictMode = function (e) {
      return h(e) === l;
    }, t.isSuspense = function (e) {
      return h(e) === f;
    }, t.isValidElementType = function (e) {
      return "string" == typeof e || "function" == typeof e || e === n || e === c || e === i || e === l || e === f || e === m || "object" == typeof e && null !== e && (e.$$typeof === x || e.$$typeof === p || e.$$typeof === a || e.$$typeof === d || e.$$typeof === u || e.$$typeof === v || e.$$typeof === _ || e.$$typeof === y || e.$$typeof === b);
    }, t.typeOf = h;
  }();
}),
    X = i(function (e) {
  "production" === process.env.NODE_ENV ? e.exports = H : e.exports = V;
}),
    U = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED",
    G = function G() {};

if ("production" !== process.env.NODE_ENV) {
  var q = U,
      Z = {},
      Y = Function.call.bind(Object.prototype.hasOwnProperty);

  G = function G(e) {
    var t = "Warning: " + e;
    "undefined" != typeof console && console.error(t);

    try {
      throw new Error(t);
    } catch (e) {}
  };
}

function Q(e, t, o, r, n) {
  if ("production" !== process.env.NODE_ENV) for (var l in e) {
    if (Y(e, l)) {
      var i;

      try {
        if ("function" != typeof e[l]) {
          var a = Error((r || "React class") + ": " + o + " type `" + l + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof e[l] + "`.");
          throw a.name = "Invariant Violation", a;
        }

        i = e[l](t, l, r, o, null, q);
      } catch (e) {
        i = e;
      }

      if (!i || i instanceof Error || G((r || "React class") + ": type specification of " + o + " `" + l + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof i + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."), i instanceof Error && !(i.message in Z)) {
        Z[i.message] = !0;
        var d = n ? n() : "";
        G("Failed " + o + " type: " + i.message + (null != d ? d : ""));
      }
    }
  }
}

Q.resetWarningCache = function () {
  "production" !== process.env.NODE_ENV && (Z = {});
};

var J = Q,
    K = Function.call.bind(Object.prototype.hasOwnProperty),
    ee = function ee() {};

function te() {
  return null;
}

"production" !== process.env.NODE_ENV && (ee = function ee(e) {
  var t = "Warning: " + e;
  "undefined" != typeof console && console.error(t);

  try {
    throw new Error(t);
  } catch (e) {}
});

var oe = function oe(e, t) {
  var o = "function" == typeof Symbol && Symbol.iterator;
  var n = {
    array: d("array"),
    bool: d("boolean"),
    func: d("function"),
    number: d("number"),
    object: d("object"),
    string: d("string"),
    symbol: d("symbol"),
    any: a(te),
    arrayOf: function arrayOf(e) {
      return a(function (t, o, r, n, l) {
        if ("function" != typeof e) return new i("Property `" + l + "` of component `" + r + "` has invalid PropType notation inside arrayOf.");
        var a = t[o];
        if (!Array.isArray(a)) return new i("Invalid " + n + " `" + l + "` of type `" + c(a) + "` supplied to `" + r + "`, expected an array.");

        for (var d = 0; d < a.length; d++) {
          var s = e(a, d, r, n, l + "[" + d + "]", U);
          if (s instanceof Error) return s;
        }

        return null;
      });
    },
    element: a(function (t, o, r, n, l) {
      var a = t[o];
      return e(a) ? null : new i("Invalid " + n + " `" + l + "` of type `" + c(a) + "` supplied to `" + r + "`, expected a single ReactElement.");
    }),
    elementType: a(function (e, t, o, r, n) {
      var l = e[t];
      return X.isValidElementType(l) ? null : new i("Invalid " + r + " `" + n + "` of type `" + c(l) + "` supplied to `" + o + "`, expected a single ReactElement type.");
    }),
    instanceOf: function instanceOf(e) {
      return a(function (t, o, r, n, l) {
        if (!(t[o] instanceof e)) {
          var a = e.name || "<<anonymous>>";
          return new i("Invalid " + n + " `" + l + "` of type `" + function (e) {
            if (!e.constructor || !e.constructor.name) return "<<anonymous>>";
            return e.constructor.name;
          }(t[o]) + "` supplied to `" + r + "`, expected instance of `" + a + "`.");
        }

        return null;
      });
    },
    node: a(function (e, t, o, r, n) {
      return s(e[t]) ? null : new i("Invalid " + r + " `" + n + "` supplied to `" + o + "`, expected a ReactNode.");
    }),
    objectOf: function objectOf(e) {
      return a(function (t, o, r, n, l) {
        if ("function" != typeof e) return new i("Property `" + l + "` of component `" + r + "` has invalid PropType notation inside objectOf.");
        var a = t[o],
            d = c(a);
        if ("object" !== d) return new i("Invalid " + n + " `" + l + "` of type `" + d + "` supplied to `" + r + "`, expected an object.");

        for (var s in a) {
          if (K(a, s)) {
            var u = e(a, s, r, n, l + "." + s, U);
            if (u instanceof Error) return u;
          }
        }

        return null;
      });
    },
    oneOf: function oneOf(e) {
      if (!Array.isArray(e)) return "production" !== process.env.NODE_ENV && ee(arguments.length > 1 ? "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])." : "Invalid argument supplied to oneOf, expected an array."), te;

      function t(t, o, r, n, a) {
        for (var d = t[o], s = 0; s < e.length; s++) {
          if (l(d, e[s])) return null;
        }

        var c = JSON.stringify(e, function (e, t) {
          return "symbol" === u(t) ? String(t) : t;
        });
        return new i("Invalid " + n + " `" + a + "` of value `" + String(d) + "` supplied to `" + r + "`, expected one of " + c + ".");
      }

      return a(t);
    },
    oneOfType: function oneOfType(e) {
      if (!Array.isArray(e)) return "production" !== process.env.NODE_ENV && ee("Invalid argument supplied to oneOfType, expected an instance of array."), te;

      for (var t = 0; t < e.length; t++) {
        var o = e[t];
        if ("function" != typeof o) return ee("Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + f(o) + " at index " + t + "."), te;
      }

      return a(function (t, o, r, n, l) {
        for (var a = 0; a < e.length; a++) {
          if (null == (0, e[a])(t, o, r, n, l, U)) return null;
        }

        return new i("Invalid " + n + " `" + l + "` supplied to `" + r + "`.");
      });
    },
    shape: function shape(e) {
      return a(function (t, o, r, n, l) {
        var a = t[o],
            d = c(a);
        if ("object" !== d) return new i("Invalid " + n + " `" + l + "` of type `" + d + "` supplied to `" + r + "`, expected `object`.");

        for (var s in e) {
          var u = e[s];

          if (u) {
            var f = u(a, s, r, n, l + "." + s, U);
            if (f) return f;
          }
        }

        return null;
      });
    },
    exact: function exact(e) {
      return a(function (t, o, n, l, a) {
        var d = t[o],
            s = c(d);
        if ("object" !== s) return new i("Invalid " + l + " `" + a + "` of type `" + s + "` supplied to `" + n + "`, expected `object`.");
        var u = r({}, t[o], e);

        for (var f in u) {
          var m = e[f];
          if (!m) return new i("Invalid " + l + " `" + a + "` key `" + f + "` supplied to `" + n + "`.\nBad object: " + JSON.stringify(t[o], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(e), null, "  "));
          var p = m(d, f, n, l, a + "." + f, U);
          if (p) return p;
        }

        return null;
      });
    }
  };

  function l(e, t) {
    return e === t ? 0 !== e || 1 / e == 1 / t : e != e && t != t;
  }

  function i(e) {
    this.message = e, this.stack = "";
  }

  function a(e) {
    if ("production" !== process.env.NODE_ENV) var o = {},
        r = 0;

    function n(n, l, a, d, s, c, u) {
      if (d = d || "<<anonymous>>", c = c || a, u !== U) {
        if (t) {
          var f = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");
          throw f.name = "Invariant Violation", f;
        }

        if ("production" !== process.env.NODE_ENV && "undefined" != typeof console) {
          var m = d + ":" + a;
          !o[m] && r < 3 && (ee("You are manually calling a React.PropTypes validation function for the `" + c + "` prop on `" + d + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."), o[m] = !0, r++);
        }
      }

      return null == l[a] ? n ? null === l[a] ? new i("The " + s + " `" + c + "` is marked as required in `" + d + "`, but its value is `null`.") : new i("The " + s + " `" + c + "` is marked as required in `" + d + "`, but its value is `undefined`.") : null : e(l, a, d, s, c);
    }

    var l = n.bind(null, !1);
    return l.isRequired = n.bind(null, !0), l;
  }

  function d(e) {
    return a(function (t, o, r, n, l, a) {
      var d = t[o];
      return c(d) !== e ? new i("Invalid " + n + " `" + l + "` of type `" + u(d) + "` supplied to `" + r + "`, expected `" + e + "`.") : null;
    });
  }

  function s(t) {
    switch (typeof t) {
      case "number":
      case "string":
      case "undefined":
        return !0;

      case "boolean":
        return !t;

      case "object":
        if (Array.isArray(t)) return t.every(s);
        if (null === t || e(t)) return !0;

        var r = function (e) {
          var t = e && (o && e[o] || e["@@iterator"]);
          if ("function" == typeof t) return t;
        }(t);

        if (!r) return !1;
        var n,
            l = r.call(t);

        if (r !== t.entries) {
          for (; !(n = l.next()).done;) {
            if (!s(n.value)) return !1;
          }
        } else for (; !(n = l.next()).done;) {
          var i = n.value;
          if (i && !s(i[1])) return !1;
        }

        return !0;

      default:
        return !1;
    }
  }

  function c(e) {
    var t = typeof e;
    return Array.isArray(e) ? "array" : e instanceof RegExp ? "object" : function (e, t) {
      return "symbol" === e || !!t && ("Symbol" === t["@@toStringTag"] || "function" == typeof Symbol && t instanceof Symbol);
    }(t, e) ? "symbol" : t;
  }

  function u(e) {
    if (null == e) return "" + e;
    var t = c(e);

    if ("object" === t) {
      if (e instanceof Date) return "date";
      if (e instanceof RegExp) return "regexp";
    }

    return t;
  }

  function f(e) {
    var t = u(e);

    switch (t) {
      case "array":
      case "object":
        return "an " + t;

      case "boolean":
      case "date":
      case "regexp":
        return "a " + t;

      default:
        return t;
    }
  }

  return i.prototype = Error.prototype, n.checkPropTypes = J, n.resetWarningCache = J.resetWarningCache, n.PropTypes = n, n;
};

function re() {}

function ne() {}

ne.resetWarningCache = re;
var le = i(function (e) {
  if ("production" !== process.env.NODE_ENV) {
    var t = X;
    e.exports = oe(t.isElement, !0);
  } else e.exports = function () {
    function e(e, t, o, r, n, l) {
      if (l !== U) {
        var i = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        throw i.name = "Invariant Violation", i;
      }
    }

    function t() {
      return e;
    }

    e.isRequired = e;
    var o = {
      array: e,
      bool: e,
      func: e,
      number: e,
      object: e,
      string: e,
      symbol: e,
      any: e,
      arrayOf: t,
      element: e,
      elementType: e,
      instanceOf: t,
      node: e,
      objectOf: t,
      oneOf: t,
      oneOfType: t,
      shape: t,
      exact: t,
      checkPropTypes: ne,
      resetWarningCache: re
    };
    return o.PropTypes = o, o;
  }();
});

function ie() {
  return (ie = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var o = arguments[t];

      for (var r in o) {
        Object.prototype.hasOwnProperty.call(o, r) && (e[r] = o[r]);
      }
    }

    return e;
  }).apply(this, arguments);
}

function ae(e, t) {
  if (null == e) return {};

  var o,
      r,
      n = function (e, t) {
    if (null == e) return {};
    var o,
        r,
        n = {},
        l = Object.keys(e);

    for (r = 0; r < l.length; r++) {
      o = l[r], t.indexOf(o) >= 0 || (n[o] = e[o]);
    }

    return n;
  }(e, t);

  if (Object.getOwnPropertySymbols) {
    var l = Object.getOwnPropertySymbols(e);

    for (r = 0; r < l.length; r++) {
      o = l[r], t.indexOf(o) >= 0 || Object.prototype.propertyIsEnumerable.call(e, o) && (n[o] = e[o]);
    }
  }

  return n;
}

var de = t(function (t, o) {
  var r = t.color,
      n = void 0 === r ? "currentColor" : r,
      l = t.size,
      i = void 0 === l ? 24 : l,
      a = ae(t, ["color", "size"]);
  return e.createElement("svg", ie({
    ref: o,
    xmlns: "http://www.w3.org/2000/svg",
    width: i,
    height: i,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: n,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, a), e.createElement("path", {
    d: "M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"
  }), e.createElement("line", {
    x1: "12",
    y1: "9",
    x2: "12",
    y2: "13"
  }), e.createElement("line", {
    x1: "12",
    y1: "17",
    x2: "12.01",
    y2: "17"
  }));
});

function se() {
  return (se = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var o = arguments[t];

      for (var r in o) {
        Object.prototype.hasOwnProperty.call(o, r) && (e[r] = o[r]);
      }
    }

    return e;
  }).apply(this, arguments);
}

function ce(e, t) {
  if (null == e) return {};

  var o,
      r,
      n = function (e, t) {
    if (null == e) return {};
    var o,
        r,
        n = {},
        l = Object.keys(e);

    for (r = 0; r < l.length; r++) {
      o = l[r], t.indexOf(o) >= 0 || (n[o] = e[o]);
    }

    return n;
  }(e, t);

  if (Object.getOwnPropertySymbols) {
    var l = Object.getOwnPropertySymbols(e);

    for (r = 0; r < l.length; r++) {
      o = l[r], t.indexOf(o) >= 0 || Object.prototype.propertyIsEnumerable.call(e, o) && (n[o] = e[o]);
    }
  }

  return n;
}

de.propTypes = {
  color: le.string,
  size: le.oneOfType([le.string, le.number])
}, de.displayName = "AlertTriangle";
var ue = t(function (t, o) {
  var r = t.color,
      n = void 0 === r ? "currentColor" : r,
      l = t.size,
      i = void 0 === l ? 24 : l,
      a = ce(t, ["color", "size"]);
  return e.createElement("svg", se({
    ref: o,
    xmlns: "http://www.w3.org/2000/svg",
    width: i,
    height: i,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: n,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, a), e.createElement("polyline", {
    points: "20 6 9 17 4 12"
  }));
});

function fe() {
  return (fe = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var o = arguments[t];

      for (var r in o) {
        Object.prototype.hasOwnProperty.call(o, r) && (e[r] = o[r]);
      }
    }

    return e;
  }).apply(this, arguments);
}

function me(e, t) {
  if (null == e) return {};

  var o,
      r,
      n = function (e, t) {
    if (null == e) return {};
    var o,
        r,
        n = {},
        l = Object.keys(e);

    for (r = 0; r < l.length; r++) {
      o = l[r], t.indexOf(o) >= 0 || (n[o] = e[o]);
    }

    return n;
  }(e, t);

  if (Object.getOwnPropertySymbols) {
    var l = Object.getOwnPropertySymbols(e);

    for (r = 0; r < l.length; r++) {
      o = l[r], t.indexOf(o) >= 0 || Object.prototype.propertyIsEnumerable.call(e, o) && (n[o] = e[o]);
    }
  }

  return n;
}

ue.propTypes = {
  color: le.string,
  size: le.oneOfType([le.string, le.number])
}, ue.displayName = "Check";
var pe = t(function (t, o) {
  var r = t.color,
      n = void 0 === r ? "currentColor" : r,
      l = t.size,
      i = void 0 === l ? 24 : l,
      a = me(t, ["color", "size"]);
  return e.createElement("svg", fe({
    ref: o,
    xmlns: "http://www.w3.org/2000/svg",
    width: i,
    height: i,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: n,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, a), e.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "10"
  }), e.createElement("line", {
    x1: "12",
    y1: "16",
    x2: "12",
    y2: "12"
  }), e.createElement("line", {
    x1: "12",
    y1: "8",
    x2: "12.01",
    y2: "8"
  }));
});

function xe() {
  return (xe = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var o = arguments[t];

      for (var r in o) {
        Object.prototype.hasOwnProperty.call(o, r) && (e[r] = o[r]);
      }
    }

    return e;
  }).apply(this, arguments);
}

pe.propTypes = {
  color: le.string,
  size: le.oneOfType([le.string, le.number])
}, pe.displayName = "Info";
var be = o("path", {
  fill: "currentColor",
  d: "M16 31C7.716 31 1 24.284 1 16 1 7.716 7.716 1 16 1c8.284 0 15 6.716 15 15 0 8.284-6.716 15-15 15zm0-3c6.627 0 12-5.373 12-12S22.627 4 16 4 4 9.373 4 16s5.373 12 12 12zm1-5.466v.415c0 1.334-2 1.334-2 0v-.415c0-1.333 2-1.333 2 0zM17 8.53V18c0 1.333-2 1.333-2 0V8.53c0-1.333 2-1.333 2 0z"
});

function ve(e) {
  return o("svg", xe({
    viewBox: "0 0 32 32",
    height: 32,
    width: 32
  }, e), be);
}

function _e() {
  return (_e = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var o = arguments[t];

      for (var r in o) {
        Object.prototype.hasOwnProperty.call(o, r) && (e[r] = o[r]);
      }
    }

    return e;
  }).apply(this, arguments);
}

var ye = o("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M23.89 11a1.5 1.5 0 012.23 2l-9 10a1.5 1.5 0 01-2.23 0l-9-10a1.5 1.5 0 112.23-2L16 19.76 23.88 11z"
});

function he(e) {
  return o("svg", _e({
    viewBox: "0 0 32 32"
  }, e), ye);
}

function ge() {
  return (ge = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var o = arguments[t];

      for (var r in o) {
        Object.prototype.hasOwnProperty.call(o, r) && (e[r] = o[r]);
      }
    }

    return e;
  }).apply(this, arguments);
}

var Se = o("circle", {
  "data-name": "Ellipse 11",
  cx: 6,
  cy: 6,
  r: 6,
  fill: "#df002a"
}),
    Ee = o("path", {
  "data-name": "Line 4 Copy 3",
  d: "M8.29 9.292L5.809 6.78l-2.48 2.512a.472.472 0 01-.663-.672l2.48-2.512L2.749 3.68a.472.472 0 11.664-.671l2.4 2.428 2.393-2.428a.472.472 0 01.663.672l-2.4 2.428 2.48 2.512a.481.481 0 01-.336.82.455.455 0 01-.323-.149z",
  fill: "#fff"
});

function we(e) {
  return o("svg", ge({
    "data-name": "Component 3 \\u2013 2",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12"
  }, e), Se, Ee);
}

var Oe = function Oe(t) {
  var o = t.show,
      r = t.collapse,
      n = void 0 !== r && r,
      l = t.message,
      i = t.classNames,
      a = t.oxford,
      d = void 0 !== a && a;
  return o && l ? e.createElement("div", {
    className: f(y, null == i ? void 0 : i.container),
    role: "presentation",
    "data-testid": "FormFieldError/Container"
  }, !d && e.createElement("span", {
    className: f(h, null == i ? void 0 : i.icon),
    role: "img",
    "data-testid": "FormFieldError/Icon"
  }, e.createElement(we, null)), e.createElement("span", {
    className: f(g, null == i ? void 0 : i.message),
    role: "alert",
    "data-testid": "FormFieldError/Message"
  }, function (e) {
    return e ? "" + e.slice(0, 1).toUpperCase() + e.slice(1) : e;
  }(l))) : n ? null : e.createElement("div", {
    className: f(y, null == i ? void 0 : i.container),
    role: "presentation",
    "data-testid": "FormFieldError/Container"
  }, " ");
},
    Ne = "field-label-module_label__IECki",
    Te = "field-label-module_optionalText__1pRTa",
    ze = "field-label-oxford-module_formLabel__1NQdz",
    Fe = function Fe(t) {
  var o = t.htmlFor,
      r = t.children,
      n = t.classNames,
      l = t.optional,
      i = t.oxford,
      a = void 0 !== i && i,
      d = f(a ? ze : Ne, null == n ? void 0 : n.label);
  return e.createElement("label", {
    htmlFor: o,
    className: d,
    "data-testid": "FormLabel"
  }, r, l && !a && e.createElement("span", {
    className: Te,
    "data-testid": "FormLabel/OptionalText"
  }, " (optional)"));
},
    je = "base-button-module_base__2M-bf",
    ke = "base-button-module_disabled__tBNWi",
    Pe = "base-button-module_fullWidth__3CnEQ",
    Ce = "base-button-module_contentBase__16Gih",
    Ie = "base-button-module_small__7WSBo",
    We = "base-button-module_spinnerSvg__10S1r",
    Le = "loading-spinner-module_loadingSpinner__2Ba8e",
    Be = "loading-spinner-module_foregroundCircle__1VjWj",
    Ae = "loading-spinner-module_backgroundCircle__1Nh3H",
    Me = function Me(t) {
  var o = t.size,
      r = void 0 === o ? 32 : o,
      n = t.classNames;
  return e.createElement("svg", {
    className: f(Le, null == n ? void 0 : n.svg),
    xmlns: "http://www.w3.org/2000/svg",
    width: r,
    height: r,
    viewBox: "0 0 32 32",
    "data-testid": "LoadingSpinner/svg"
  }, e.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "11",
    className: f(Ae, null == n ? void 0 : n.circleBackground),
    "data-testid": "LoadingSpinner/svg/circle"
  }), e.createElement("path", {
    d: "M5,16a11,11 0 1,0 22,0a11,11 0 1,0 -22,0",
    className: f(Be, null == n ? void 0 : n.circleForeground),
    "data-testid": "LoadingSpinner/svg/path"
  }));
},
    De = "svg-module_container__2Y4WJ",
    Re = {
  deepPurple: "#311C77",
  vividViolet: "#8C32BE",
  pearlescentPink: "#FF2DFF",
  monza: "#FF332D",
  warmOrange: "#F3755D",
  brightSun: "#FDD835",
  vidaLoca: "#3ABF1F",
  toreaBay: "#1565C0",
  goGreen: "#8DFFBE",
  iceBlue: "#57E8FF",
  linen: "#FBECE7",
  serenade: "#FCEDE0",
  earlyDawn: "#FFFAE7",
  tara: "#E4F1E0",
  water: "#ECF5FA",
  acadia: "#000000",
  mineShaft: "#2F2F2F",
  asphaltGrey: "#A9A9A9",
  gainsboro: "#E8E8E8",
  wildSand: "#F5F5F5",
  pampas: "#FFFFFF",
  meteorite: "#311C77",
  malibu: "#57E8FF",
  mercury: "#A9A9A9",
  dove: "#656565"
},
    $e = {
  "5xl": "72px",
  "4xl": "42px",
  "3xl": "32px",
  xxl: "28px",
  xl: "24px",
  l: "22px",
  m: "18px",
  s: "16px",
  xs: "14px",
  "3xs": "12px",
  "4xs": "10px"
},
    He = {
  none: "0",
  xs: "4px",
  s: "8px",
  m: "16px",
  l: "20px",
  xl: "32px",
  xxl: "64px"
},
    Ve = {
  xxxs: {
    min: 375,
    max: 0
  },
  xxs: {
    min: 0,
    max: 599
  },
  xs: {
    min: 600,
    max: 767
  },
  s: {
    min: 768,
    max: 1023
  },
  m: {
    min: 1024,
    max: 1439
  },
  l: {
    min: 1440,
    max: 1919
  },
  xl: {
    min: 1920,
    max: 1 / 0
  }
},
    Xe = {
  xxxs: "(min-width: " + Ve.xxxs.min + "px)",
  xxs: "(max-width: " + Ve.xxs.max + "px)",
  xs: "(min-width: " + Ve.xs.min + "px)",
  s: "(min-width: " + Ve.s.min + "px)",
  m: "(min-width: " + Ve.m.min + "px)",
  l: "(min-width: " + Ve.l.min + "px)",
  xl: "(min-width: " + Ve.xl.min + "px)",
  mediumPhone: "(min-height: " + Ve.xxs.max + "px)",
  mediumDesktop: "(min-height: " + Ve.s.min + "px) and (min-width: " + Ve.m.min + "px)"
},
    Ue = {
  customProperties: {
    ds: {
      breakpoint: Ve,
      color: Re,
      opacities: {
        low: .25,
        medium: .5,
        high: .75
      },
      spacing: He,
      dimensions: {
        slim: "1024px",
        max: "1280px"
      },
      font: {
        family: "'Buenos Aires', Avenir, Futura, Arial, SansSerif, sans-serif`",
        size: $e,
        weight: {
          light: 200,
          book: 300,
          medium: 400,
          semibold: 600,
          bold: 700
        },
        "line-height": {
          display: 1.35,
          body: 1.55
        }
      },
      components: {
        alert: {
          color: Re.mineShaft,
          padding: He.m,
          "icon-margin": He.s,
          "icon-size": "20px",
          "border-radius": "8px",
          "error-bg": Re.linen,
          "error-border": "1px solid " + Re.warmOrange,
          "success-bg": Re.tara,
          "success-border": "1px solid " + Re.vidaLoca,
          "info-bg": "var(--ds-color-water)",
          "info-border": "1px solid " + Re.toreaBay,
          "warning-bg": Re.earlyDawn,
          "warning-border": "1px solid " + Re.brightSun,
          "oxd-color": Re.monza,
          "oxd-padding": He.m,
          "oxd-icon-margin": He.m,
          "oxd-icon-size": "32px",
          "oxd-border-radius": "8px",
          "oxd-error-bg": "transparent",
          "oxd-error-border": "2px solid " + Re.monza,
          "oxd-success-bg": "transparent",
          "oxd-success-border": "2px solid " + Re.monza,
          "oxd-info-bg": "transparent",
          "oxd-info-border": "2px solid " + Re.monza,
          "oxd-warning-bg": "transparent",
          "oxd-warning-border": "2px solid " + Re.monza
        },
        "field-label": {
          "margin-bottom": He.s,
          color: Re.meteorite
        },
        "field-text": {
          bg: Re.pampas,
          color: Re.meteorite,
          "border-color": Re.mercury,
          "placeholder-color": Re.mercury,
          "disabled-color": Re.mercury,
          "disabled-bg": Re.gainsboro,
          "focus-border-color": Re.meteorite,
          "hover-border-color": Re.mineShaft,
          "disabled-border-color": "transparent",
          "invalid-border-color": Re.monza
        },
        "field-error": {
          color: Re.monza,
          "font-size": $e["3xs"],
          "icon-margin-right": He.xs,
          "margin-top": He.xs
        },
        "inline-radio": {
          color: Re.mineShaft,
          borderColor: Re.gainsboro,
          focusedBg: Re.wildSand,
          "checked-border": Re.vidaLoca
        },
        "form-field": {
          color: Re.mineShaft,
          padding: He.l + " " + He.m,
          border: "1px solid " + Re.asphaltGrey,
          "border-radius": "3px",
          "placeholder-color": Re.asphaltGrey,
          "hover-border-color": Re.mineShaft,
          "focus-border-color": Re.meteorite,
          "disabled-color": Re.asphaltGrey,
          "disabled-background-color": Re.wildSand,
          "error-border-color": Re.monza
        },
        select: {
          "arrow-color": Re.meteorite,
          "arrow-size": "24px"
        },
        button: {
          primary: {
            default: {
              "border-color": "transparent",
              "border-focus-color": Re.malibu,
              "content-bg-color": Re.toreaBay,
              "content-fg-color": Re.pampas,
              "content-hover-bg-color": Re.meteorite,
              "spinner-stroke-color": Re.pampas
            },
            alt: {
              "content-bg-color": Re.malibu,
              "content-fg-color": Re.meteorite,
              "spinner-stroke-color": Re.pampas
            }
          },
          secondary: {
            default: {
              "border-color": "transparent",
              "border-focus-color": Re.malibu,
              "content-bg-color": Re.pampas,
              "content-fg-color": Re.toreaBay,
              "content-border-color": Re.toreaBay,
              "spinner-stroke-color": Re.toreaBay
            },
            alt: {
              "content-bg-color": "transparent",
              "content-fg-color": Re.pampas,
              "content-border-color": Re.pampas,
              "spinner-stroke-color": Re.pampas
            }
          },
          warning: {
            default: {
              "border-color": "transparent",
              "border-focus-color": Re.malibu,
              "content-bg-color": Re.monza,
              "content-fg-color": Re.pampas,
              "content-hover-bg-color": Re.warmOrange,
              "spinner-stroke-color": Re.pampas
            }
          },
          text: {
            default: {
              "border-color": "transparent",
              "border-focus-color": Re.malibu,
              "content-fg-color": Re.meteorite,
              "content-hover-fg-color": Re.vividViolet
            },
            alt: {
              "content-fg-color": Re.pampas,
              "content-hover-fg-color": Re.malibu
            }
          }
        }
      }
    }
  },
  customMedia: Xe
},
    Ge = function Ge(e) {
  return null != e && null != e.constructor && "function" == typeof e.constructor.isBuffer && e.constructor.isBuffer(e);
},
    qe = Ye;

function Ze(e) {
  return e;
}

function Ye(e, t) {
  var o = (t = t || {}).delimiter || ".",
      r = t.maxDepth,
      n = t.transformKey || Ze,
      l = {};
  return function e(i, a, d) {
    d = d || 1, Object.keys(i).forEach(function (s) {
      var c = i[s],
          u = t.safe && Array.isArray(c),
          f = Object.prototype.toString.call(c),
          m = Ge(c),
          p = "[object Object]" === f || "[object Array]" === f,
          x = a ? a + o + n(s) : n(s);
      if (!u && !m && p && Object.keys(c).length && (!t.maxDepth || d < r)) return e(c, x, d + 1);
      l[x] = c;
    });
  }(e), l;
}

Ye.flatten = Ye, Ye.unflatten = function e(t, o) {
  var r = (o = o || {}).delimiter || ".",
      n = o.overwrite || !1,
      l = o.transformKey || Ze,
      i = {};
  if (Ge(t) || "[object Object]" !== Object.prototype.toString.call(t)) return t;

  function a(e) {
    var t = Number(e);
    return isNaN(t) || -1 !== e.indexOf(".") || o.object ? e : t;
  }

  return t = Object.keys(t).reduce(function (e, n) {
    var l = Object.prototype.toString.call(t[n]);
    return !("[object Object]" === l || "[object Array]" === l) || function (e) {
      var t = Object.prototype.toString.call(e),
          o = "[object Array]" === t,
          r = "[object Object]" === t;
      if (!e) return !0;
      if (o) return !e.length;
      if (r) return !Object.keys(e).length;
    }(t[n]) ? (e[n] = t[n], e) : function (e, t, o) {
      return Object.keys(o).reduce(function (t, n) {
        return t[e + r + n] = o[n], t;
      }, t);
    }(n, e, Ye(t[n], o));
  }, {}), Object.keys(t).forEach(function (d) {
    var s = d.split(r).map(l);
    var c = a(s.shift()),
        u = a(s[0]),
        f = i;

    for (; void 0 !== u;) {
      var _e2 = Object.prototype.toString.call(f[c]),
          _t2 = "[object Object]" === _e2 || "[object Array]" === _e2;

      if (!n && !_t2 && void 0 !== f[c]) return;
      (n && !_t2 || !n && null == f[c]) && (f[c] = "number" != typeof u || o.object ? {} : []), f = f[c], s.length > 0 && (c = a(s.shift()), u = a(s[0]));
    }

    f[c] = e(t[d], o);
  }), i;
};

var Qe = function Qe(e, t) {
  var o = qe(e, {
    delimiter: "-"
  });
  return Object.keys(o).reduce(function (e, r) {
    var l;
    return _n(_n({}, e), ((l = {})["" + t + r] = o[r], l));
  }, {});
},
    Je = function Je(e) {
  var t = e.customMedia,
      o = e.customProperties;
  return {
    customMedia: Qe(t, "--"),
    customProperties: Qe(o, "--")
  };
},
    Ke = {
  alpha: "svg-gradient-alpha",
  bravo: "svg-gradient-bravo",
  charlie: "svg-gradient-charlie",
  delta: "svg-gradient-delta"
},
    et = Ue.customProperties.ds.color,
    tt = (et.deepPurple, et.pearlescentPink, et.iceBlue, et.goGreen, et.vividViolet, et.iceBlue, et.vividViolet, et.warmOrange, function (t) {
  var o = t.className,
      r = t.fill,
      n = t.stroke,
      l = void 0 === n ? "none" : n,
      i = t.size,
      a = t.width,
      d = t.height,
      s = t.children,
      c = t.preserveAspectRatio,
      u = t.verticalAlign,
      m = t.styles,
      p = t.hasGradient,
      x = void 0 !== p && p,
      b = t.gradientId,
      v = void 0 === b ? "alpha" : b,
      _ = t.dataTestId,
      y = i || d,
      h = i || a,
      g = x ? "url(#" + Ke[v] + ")" : "",
      S = s;
  return e.createElement("div", {
    className: f(De, [o, m && m.svg]),
    style: {
      height: y,
      width: h
    },
    role: "presentation",
    "data-testid": _
  }, e.createElement(S, {
    preserveAspectRatio: c,
    height: y,
    width: h,
    fill: x ? g : r,
    style: {
      display: "flex",
      width: h,
      height: y,
      fill: x ? g : r,
      stroke: l,
      verticalAlign: u
    }
  }));
});

tt.defaultProps = {
  hasGradient: !1,
  size: void 0,
  width: "100%",
  height: "100%",
  className: "",
  preserveAspectRatio: "xMidYMid",
  fill: "currentColor",
  verticalAlign: "middle",
  styles: {}
};

var ot,
    rt = {
  base: "oxd-base-button-module_base__19MRE",
  disabled: "oxd-base-button-module_disabled__3T3Z-",
  mini: "oxd-base-button-module_mini__1o3RL",
  regular: "oxd-base-button-module_regular__3c4TZ",
  large: "oxd-base-button-module_large__38pI3",
  fullWidth: "oxd-base-button-module_fullWidth__H5ga0",
  loading: "oxd-base-button-module_loading__3ZD6H",
  icon: "oxd-base-button-module_icon__3T4u7",
  content: "oxd-base-button-module_content__3xSBq",
  iconLoading: "oxd-base-button-module_iconLoading__5BwYN",
  contentLoading: "oxd-base-button-module_contentLoading__2P_hH",
  spinner: "oxd-base-button-module_spinner__2gPxJ"
},
    nt = function nt(e) {
  return ["mini", "regular", "large"].includes(e);
},
    lt = function lt(t) {
  var o,
      r,
      i,
      a = t.size,
      d = void 0 === a ? "regular" : a,
      s = t.disabled,
      c = t.isFullWidth,
      u = t.isLoading,
      m = t.styles,
      p = t.className,
      x = t.icon,
      b = t.iconProps,
      v = t.children,
      _ = l(t, ["size", "disabled", "isFullWidth", "isLoading", "styles", "className", "icon", "iconProps", "children"]),
      y = _n(_n({}, rt), m),
      h = f(y.base, y.button, function (e) {
    switch (e) {
      case "large":
        return rt.large;

      case "mini":
        return rt.mini;

      case "regular":
      default:
        return rt.regular;
    }
  }(d), ((o = {})[y.disabled] = s, o[y.fullWidth] = c, o[y.loading] = u, o), p),
      g = {
    svg: null == rt ? void 0 : rt.spinner
  },
      S = _n(_n({}, _), s || u ? {
    disabled: "disabled"
  } : {});

  return e.createElement("button", _n({
    className: h,
    "data-testid": "BaseButton/Oxford/button"
  }, S), e.createElement("div", {
    className: f(y.content, (r = {}, r[rt.contentLoading] = u, r))
  }, x && e.createElement("div", {
    className: f(rt.icon, (i = {}, i[rt.iconLoading] = u, i))
  }, e.createElement(tt, _n({}, b, {
    size: "14px",
    hasGradient: !0
  }), x)), v), u && e.createElement(Me, {
    classNames: g,
    size: 28
  }));
},
    it = function it(t) {
  var o,
      r,
      i,
      a,
      d,
      s = t.size,
      c = void 0 === s ? "small" : s,
      u = t.disabled,
      m = void 0 !== u && u,
      p = t.isLoading,
      x = void 0 !== p && p,
      b = t.isFullWidth,
      v = void 0 !== b && b,
      _ = t.classNames,
      y = t.children,
      h = t.oxford,
      g = void 0 !== h && h,
      S = t.oxdStyles,
      E = t.oxdClassName,
      w = t.oxdIcon,
      O = t.oxdIconProps,
      N = l(t, ["size", "disabled", "isLoading", "isFullWidth", "classNames", "children", "oxford", "oxdStyles", "oxdClassName", "oxdIcon", "oxdIconProps"]);
  if (g) return e.createElement(lt, _n({
    styles: S,
    size: nt(c) ? c : void 0,
    disabled: m,
    isFullWidth: v,
    isLoading: x,
    className: E,
    icon: w,
    iconProps: O
  }, N), y);
  var T = f(je, ((o = {})[Pe] = v, o[ke] = m, o), null == _ ? void 0 : _.button),
      z = f(Ce, ((r = {})[Ie] = "small" === c, r), null == _ ? void 0 : _.content),
      F = {
    svg: f(We, null === (i = null == _ ? void 0 : _.loadingSpinner) || void 0 === i ? void 0 : i.svg),
    circleForeground: null === (a = null == _ ? void 0 : _.loadingSpinner) || void 0 === a ? void 0 : a.circleForeground,
    circleBackground: null === (d = null == _ ? void 0 : _.loadingSpinner) || void 0 === d ? void 0 : d.circleBackground
  };
  return e.createElement("button", _n({
    className: T,
    "data-testid": "BaseButton/button",
    disabled: m
  }, N), e.createElement("div", {
    className: z,
    "data-testid": "BaseButton/content"
  }, x && e.createElement(Me, {
    size: 16,
    classNames: F
  }), y));
},
    at = "primary-module_button__2Ghk2",
    dt = "primary-module_disabled__r3t0R",
    st = "primary-module_alternative__naWa4",
    ct = "primary-module_content__18nZ3",
    ut = "primary-module_spinnerCircleForeground__746vI",
    ft = {
  button: "primary-oxford-module_button__-slSy",
  disabled: "primary-oxford-module_disabled__ruMkw"
},
    mt = function mt(t) {
  var o,
      r,
      i,
      a,
      d = t.size,
      s = t.disabled,
      c = void 0 !== s && s,
      u = t.variant,
      m = void 0 === u ? "default" : u,
      p = t.classNames,
      x = t.children,
      b = l(t, ["size", "disabled", "variant", "classNames", "children"]),
      v = f(at, ((o = {})[dt] = c, o[st] = "alternative" === m, o)),
      _ = f(ct, ((r = {})[dt] = c, r[st] = "alternative" === m, r)),
      y = {
    button: f(v, null == p ? void 0 : p.button),
    content: f(_, null == p ? void 0 : p.content),
    loadingSpinner: _n(_n({}, null == p ? void 0 : p.loadingSpinner), {
      circleForeground: f(ut, null === (a = null == p ? void 0 : p.loadingSpinner) || void 0 === a ? void 0 : a.circleForeground, (i = {}, i[st] = "alternative" === m, i))
    })
  };

  return e.createElement(it, _n({
    size: d,
    disabled: c,
    classNames: y
  }, b, {
    oxdStyles: ft
  }), x);
},
    pt = "secondary-module_button__3oO80",
    xt = "secondary-module_disabled__2L-Rj",
    bt = "secondary-module_alternative__2ccj2",
    vt = "secondary-module_content__j7ELG",
    _t = "secondary-module_spinnerCircleForeground__21921",
    yt = {
  button: "secondary-oxford-module_button__Pj4Qi",
  disabled: "secondary-oxford-module_disabled__Q7h-9"
},
    ht = function ht(t) {
  var o,
      r,
      i,
      a,
      d = t.size,
      s = t.disabled,
      c = void 0 !== s && s,
      u = t.variant,
      m = void 0 === u ? "default" : u,
      p = t.classNames,
      x = t.children,
      b = l(t, ["size", "disabled", "variant", "classNames", "children"]),
      v = f(pt, ((o = {})[xt] = c, o[bt] = "alternative" === m, o)),
      _ = f(vt, ((r = {})[xt] = c, r[bt] = "alternative" === m, r)),
      y = {
    button: f(v, null == p ? void 0 : p.button),
    content: f(_, null == p ? void 0 : p.content),
    loadingSpinner: _n(_n({}, null == p ? void 0 : p.loadingSpinner), {
      circleForeground: f(_t, null === (a = null == p ? void 0 : p.loadingSpinner) || void 0 === a ? void 0 : a.circleForeground, (i = {}, i[bt] = "alternative" === m, i))
    })
  };

  return e.createElement(it, _n({
    size: d,
    disabled: c,
    classNames: y
  }, b, {
    oxdStyles: yt
  }), x);
},
    gt = "warning-module_button__3IiU-",
    St = "warning-module_disabled__3dRtX",
    Et = "warning-module_content__2mDM7",
    wt = "warning-module_spinnerCircleForeground__2o5kr",
    Ot = function Ot(t) {
  var o,
      r,
      i,
      a = t.size,
      d = t.disabled,
      s = void 0 !== d && d,
      c = t.classNames,
      u = t.children,
      m = l(t, ["size", "disabled", "classNames", "children"]),
      p = {
    button: f(gt, null == c ? void 0 : c.button, (o = {}, o[St] = s, o)),
    content: f(Et, (r = {}, r[St] = s, r)),
    loadingSpinner: _n(_n({}, null == c ? void 0 : c.loadingSpinner), {
      circleForeground: f(wt, null === (i = null == c ? void 0 : c.loadingSpinner) || void 0 === i ? void 0 : i.circleForeground)
    })
  };
  return e.createElement(it, _n({
    size: a,
    disabled: s,
    classNames: p
  }, m), u);
},
    Nt = "text-module_button__32vqr",
    Tt = "text-module_disabled__322t8",
    zt = "text-module_content__2CXIA",
    Ft = "text-module_alternative__1YObC",
    jt = function jt(t) {
  var o,
      r,
      i = t.disabled,
      a = void 0 !== i && i,
      d = t.classNames,
      s = t.variant,
      c = t.children,
      u = l(t, ["disabled", "classNames", "variant", "children"]),
      m = {
    button: f(Nt, null == d ? void 0 : d.button, ((o = {})[Tt] = a, o[Ft] = "alternative" === s, o)),
    content: f(zt, ((r = {})[Tt] = a, r[Ft] = "alternative" === s, r))
  };
  return e.createElement(it, _n({
    size: "large",
    disabled: a,
    classNames: m
  }, u), c);
},
    kt = "select-module_select__3gHjn",
    Pt = "select-module_placeholder__sxuyw",
    Ct = "select-module_disabled__vQypF",
    It = "select-module_error__3ZPkT",
    Wt = "select-module_option__1SCxB",
    Lt = "select-oxford-module_input__2Wc5z",
    Bt = "select-oxford-module_hasPlaceholder__yb3f3",
    At = "select-oxford-module_option__28hos",
    Mt = "select-oxford-module_disabled__26ZMJ",
    Dt = "select-oxford-module_invalid__23OXH",
    Rt = "select-oxford-module_valid__ydy_P",
    $t = function $t(t) {
  var o,
      r,
      i = t.options,
      a = t.placeholder,
      d = t.placeholderValue,
      s = t.disabled,
      c = t.value,
      u = t.error,
      m = void 0 === u ? {
    show: !1,
    collapse: !1
  } : u,
      p = t.classNames,
      x = t.oxford,
      b = void 0 !== x && x,
      v = t.oxdDisplayInvalid,
      _ = t.oxdDisplayValid,
      y = l(t, ["options", "placeholder", "placeholderValue", "disabled", "value", "error", "classNames", "oxford", "oxdDisplayInvalid", "oxdDisplayValid"]),
      h = b ? f(Lt, ((o = {})[Dt] = v, o[Rt] = _, o[Mt] = s || 0 === i.length, o[Bt] = !c, o), null == p ? void 0 : p.select) : f(kt, ((r = {})[Ct] = s, r[It] = null == m ? void 0 : m.show, r[Pt] = !c, r), null == p ? void 0 : p.select),
      g = f(b ? At : Wt, null == p ? void 0 : p.option);
  return e.createElement("select", _n({
    className: h,
    value: c,
    disabled: s
  }, y), a && e.createElement("option", {
    value: d,
    hidden: !d,
    "data-testid": "SelectField/Placeholder"
  }, a), i.map(function (t) {
    var o = t.label,
        r = t.value,
        n = t.disabled;
    return e.createElement("option", {
      key: r,
      value: r,
      disabled: n,
      "data-testid": "SelectField/Option",
      className: g
    }, o);
  }));
},
    Ht = {
  textarea: "textarea-oxford-module_textarea__3nDFq",
  fullWidth: "textarea-oxford-module_fullWidth__2BIct",
  invalid: "textarea-oxford-module_invalid__iwlBW",
  valid: "textarea-oxford-module_valid__2m904"
},
    Vt = "textarea-module_textarea__2i5C2",
    Xt = "textarea-module_fullWidth__3QwPh",
    Ut = "textarea-module_disabled__HaBcm",
    Gt = "textarea-module_error__2zdyG",
    qt = function qt(t) {
  var o,
      r,
      i = t.classNames,
      a = t.disabled,
      d = t.error,
      s = t.fullWidth,
      c = t.oxdDisplayInvalid,
      u = t.oxdDisplayValid,
      m = t.oxford,
      p = t.placeholder,
      x = t.value,
      b = l(t, ["classNames", "disabled", "error", "fullWidth", "oxdDisplayInvalid", "oxdDisplayValid", "oxford", "placeholder", "value"]),
      v = m ? f(Ht.textarea, ((o = {})[Ht.invalid] = c, o[Ht.valid] = u, o[Ht.disabled] = a, o[Ht.fullWidth] = s, o), null == i ? void 0 : i.textarea) : f(Vt, ((r = {})[Ut] = a, r[Gt] = null == d ? void 0 : d.show, r[Xt] = s, r), null == i ? void 0 : i.textarea);
  return e.createElement("textarea", _n({
    "data-testid": "Textarea",
    placeholder: p,
    className: v,
    disabled: a,
    value: x
  }, b));
},
    Zt = {
  inlineRadioText: "inline-radio-module_inlineRadioText__2_d7N",
  inlineRadioInput: "inline-radio-module_inlineRadioInput__3ogM9"
},
    Yt = "inline-radio-oxford-module_inlineRadioText__3uApZ",
    Qt = "inline-radio-oxford-module_inlineRadioInput__H85Ha",
    Jt = function Jt(t) {
  var o = t.children,
      r = t.htmlFor,
      i = t.classNames,
      a = t.name,
      d = t.checked,
      s = t.value,
      c = t.oxford,
      u = void 0 !== c && c,
      m = l(t, ["children", "htmlFor", "classNames", "name", "checked", "value", "oxford"]),
      p = f(u ? Yt : Zt.inlineRadioText, null == i ? void 0 : i.label),
      x = f(u ? Qt : Zt.inlineRadioInput, null == i ? void 0 : i.input);
  return e.createElement("div", {
    className: f(Zt.inlineRadio, null == i ? void 0 : i.container)
  }, e.createElement("input", _n({
    type: "radio",
    name: a,
    id: r,
    className: x,
    defaultChecked: d,
    value: s
  }, m)), e.createElement("label", {
    htmlFor: r,
    className: p
  }, o));
},
    Kt = {
  alert: "alert-module_alert__aqM8l",
  alertIcon: "alert-module_alertIcon__1EMJC",
  alertError: "alert-module_alertError__mcOCN",
  alertSuccess: "alert-module_alertSuccess__3jcte",
  alertWarning: "alert-module_alertWarning__1InQV",
  alertInfo: "alert-module_alertInfo__21orB"
},
    eo = "alert-oxford-module_alertOxd__2tuHd",
    to = "alert-oxford-module_alertIconOxd__3Xyzh";

!function (e) {
  e.error = "error", e.warning = "warning", e.info = "info", e.success = "success";
}(ot || (ot = {}));

var oo = function oo(t) {
  var o,
      r = t.children,
      n = t.type,
      l = void 0 === n ? "error" : n,
      i = t.oxford,
      s = void 0 !== i && i,
      c = t.className,
      u = s ? f(eo, c) : f(Kt.alert, Kt["alert" + (o = l, o.charAt(0).toUpperCase() + o.slice(1))], c),
      m = {
    oxford: ve,
    error: de,
    success: ue,
    warning: de,
    info: pe
  },
      p = s ? m.oxford : m[l];
  return e.createElement("div", {
    "data-testid": "ds-alert",
    role: "alert",
    className: u
  }, e.createElement("div", {
    className: s ? to : Kt.alertIcon
  }, e.createElement(p, null)), e.createElement(_, {
    fontSize: a["3xs"],
    fontWeight: d.book
  }, r));
},
    ro = "select-field-module_wrapper__2qq2o",
    no = "select-field-module_svg__1isdb",
    lo = "select-field-module_muted__20eUE",
    io = "select-field-oxford-module_field__2kzNb",
    ao = "select-field-oxford-module_wrapper__1BVhh",
    so = "select-field-oxford-module_svg__1qgsM",
    co = "select-field-oxford-module_muted__2m-k9",
    uo = function uo(t) {
  var o,
      r,
      i = t.id,
      a = t.label,
      d = t.disabled,
      s = t.optional,
      c = t.error,
      m = void 0 === c ? {
    show: !1,
    collapse: !1
  } : c,
      p = t.value,
      x = t.classNames,
      b = t.oxford,
      v = void 0 !== b && b,
      y = t.oxdClassName,
      h = t.oxdHelpText,
      g = l(t, ["id", "label", "disabled", "optional", "error", "value", "classNames", "oxford", "oxdClassName", "oxdHelpText"]),
      S = v ? f(so, ((o = {})[co] = d, o), null == x ? void 0 : x.arrow) : f(no, ((r = {})[lo] = d, r), null == x ? void 0 : x.arrow),
      E = v ? f(io, y, null == x ? void 0 : x.container) : f(null == x ? void 0 : x.container),
      w = f(v ? ao : ro, null == x ? void 0 : x.selectWrapper);
  return e.createElement("div", {
    className: E,
    "data-field": i
  }, a && e.createElement(Fe, {
    htmlFor: i,
    oxford: v,
    optional: s
  }, a), v && h && e.createElement(_, {
    type: u.fieldHelpText,
    element: "p",
    oxford: !0
  }, h), e.createElement("div", {
    className: w
  }, e.createElement($t, _n({
    id: i,
    error: m,
    disabled: d,
    value: p,
    "data-testid": "SelectField/Select",
    classNames: {
      select: null == x ? void 0 : x.select,
      option: null == x ? void 0 : x.option
    },
    oxford: v
  }, g)), e.createElement("div", {
    className: S,
    "data-testid": "SelectField/ArrowIcon"
  }, e.createElement(he, null))), e.createElement(Oe, _n({}, m, {
    oxford: v
  })));
},
    fo = "inline-radio-field-module_inlineRadioGroup__1O_Al",
    mo = "inline-radio-field-module_inlineRadioGroupOptions__3qzDy",
    po = "inline-radio-field-module_inlineRadioGroupInput__1St7m",
    xo = "inline-radio-field-module_inlineRadioLabel__2Ursn",
    bo = "inline-radio-field-module_inlineRadioGroupSubLabel__OuDif",
    vo = "inline-radio-field-oxford-module_label__VcwBt",
    _o = function _o(e, t) {
  return void 0 === e || "string" == typeof e ? e : e(t);
},
    yo = function yo(t) {
  var o,
      r = t.options,
      i = t.label,
      a = t.name,
      d = t.error,
      s = void 0 === d ? {
    show: !1,
    collapse: !1
  } : d,
      c = t.classNames,
      u = t.oxford,
      m = void 0 !== u && u,
      p = l(t, ["options", "label", "name", "error", "classNames", "oxford"]),
      x = f(m ? vo : xo, null == c ? void 0 : c.legend),
      b = _n(_n({}, null == c ? void 0 : c.radio), {
    container: f(po, null === (o = null == c ? void 0 : c.radio) || void 0 === o ? void 0 : o.container)
  });

  return e.createElement("fieldset", {
    className: f(fo, null == c ? void 0 : c.fieldset)
  }, e.createElement("legend", {
    className: x
  }, i), e.createElement("div", {
    className: f(mo, null == c ? void 0 : c.container)
  }, r.map(function (t) {
    var o = t.value,
        r = t.id,
        l = t.label,
        i = t.subLabel,
        d = p.value && o === p.value,
        s = _o(l, d),
        u = _o(i, d);

    return e.createElement(Jt, _n({}, p, {
      key: r,
      name: a,
      htmlFor: r,
      value: o,
      classNames: b,
      oxford: m,
      "data-testid": "radio-input",
      checked: d
    }), e.createElement("span", {
      className: f(null == c ? void 0 : c.labelText)
    }, s), u && !m && e.createElement(_, {
      element: "span",
      className: f(bo, null == c ? void 0 : c.subLabelText),
      fontSize: "3xs",
      "data-testid": "RadioField/SubLabelText"
    }, u));
  })), e.createElement(Oe, {
    show: s.show,
    message: s.message,
    collapse: s.collapse,
    oxford: m,
    classNames: null == c ? void 0 : c.error
  }));
},
    ho = "textarea-field-module_fullWidth__2qZS_",
    go = "textarea-field-oxford-module_fullWidth__3U1rm",
    So = function So(t) {
  var o,
      r,
      i = t.id,
      a = t.classNames,
      d = t.disabled,
      s = t.error,
      c = void 0 === s ? {
    show: !1,
    collapse: !1
  } : s,
      m = t.fullWidth,
      p = t.label,
      x = t.optional,
      b = t.value,
      v = t.oxdHelpText,
      y = t.oxford,
      h = void 0 !== y && y,
      g = l(t, ["id", "classNames", "disabled", "error", "fullWidth", "label", "optional", "value", "oxdHelpText", "oxford"]),
      S = f(h ? ((o = {})[go] = m, o) : ((r = {})[ho] = m, r), null == a ? void 0 : a.fieldWrapper);
  return e.createElement("div", {
    className: S,
    "data-field": i,
    "data-testid": "TextareaField/Wrapper"
  }, p && e.createElement(Fe, {
    htmlFor: i,
    oxford: h,
    optional: x,
    classNames: null == a ? void 0 : a.label
  }, p), h && v && e.createElement(_, {
    type: u.fieldHelpText,
    element: "p",
    oxford: !0
  }, v), e.createElement(qt, _n({
    id: i,
    error: c,
    disabled: d,
    value: b,
    "data-testid": "TextareaField/Textarea",
    classNames: {
      textarea: null == a ? void 0 : a.textarea
    },
    oxford: h
  }, g)), e.createElement(Oe, _n({}, c, {
    classNames: null == a ? void 0 : a.error,
    oxford: h
  })));
};

export { oo as Alert, ot as AlertTypes, it as Base, Oe as FormFieldError, Fe as FormLabel, Jt as InlineRadio, yo as InlineRadioField, mt as Primary, ht as Secondary, $t as Select, uo as SelectField, _ as Text, jt as TextButton, a as TextFontSizes, c as TextFontStyles, d as TextFontWeights, s as TextLineHeights, u as TextStyles, qt as Textarea, So as TextareaField, Ot as Warning, Ue as designTokens, Je as toJSON };